/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import * as aes from 'aes-js';
import * as scrypt from 'scrypt-async';
import { Nugget } from './nugget.interface';

@Injectable({
  providedIn: 'root',
})
export class AesService {
  async decrypt(encryptedResponse: Response, nugget: Nugget) {
    const { a: pass, b: salt } = nugget;
    const splitted = encryptedResponse.url.split('/');
    const id = splitted[splitted.length - 1];

    let key;

    scrypt(
      `${pass}${id}`,
      salt,
      {
        N: 1024,
        r: 8,
        p: 1,
        dkLen: 32,
      },
      async derivedKey => (key = await derivedKey),
    );

    const encryptedArrayBuffer = await encryptedResponse.arrayBuffer();
    const encryptedUint8Array = new Uint8Array(encryptedArrayBuffer);
    const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(5));
    const decryptedUint8Array = aesCtr.decrypt(encryptedUint8Array);

    return new Blob([new Uint8Array(decryptedUint8Array.buffer, 0, decryptedUint8Array.length)]);
  }

  // async newDecrypt(base64: string, nugget: Nugget) {
  //   const { a: pass, b: salt } = nugget;
  //   // const splitted = encryptedResponse.url.split('/');
  //   const id = base64[base64.length - 1];

  //   let key;

  //   scrypt(
  //     `${pass}${id}`,
  //     salt,
  //     {
  //       N: 1024,
  //       r: 8,
  //       p: 1,
  //       dkLen: 32,
  //     },
  //     async derivedKey => (key = await derivedKey),
  //   );

  //   // const encryptedArrayBuffer = await encryptedResponse.arrayBuffer();
  //   // const encryptedUint8Array = new Uint8Array(encryptedArrayBuffer);
  //   const aesCtr = new aes.ModeOfOperation.ctr(key, new aes.Counter(5));
  //   const decryptedBase64 = aesCtr.decrypt(base64);

  //   return decryptedBase64;
  // }

  async new2Decrypt(url: string, bytes: Uint8Array, base64: string, nugget: Nugget) {
    const { a: pass, b: salt } = nugget;
    const splitted = url.split('/');
    const id = splitted[splitted.length - 1];

    let key;

    await scrypt(
      `${pass}${id}`,
      salt,
      {
        N: 1024,
        r: 8,
        p: 1,
        dkLen: 32,
      },
      async derivedKey => (key = await derivedKey),
    );

    const aesCtr = new aes.ModeOfOperation.ctr(await key, new aes.Counter(5));
    const decryptedUint8Array = aesCtr.decrypt(bytes);

    return decryptedUint8Array.buffer;

    // return new Blob([new Uint8Array(decryptedUint8Array.buffer, 0, decryptedUint8Array.length)], { type: 'audio/mp3' });

    // const unit8array = new Uint8Array(decryptedUint8Array.buffer, 0, decryptedUint8Array.length);
    // return unit8array;
  }
}
